import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  buildAvailableSpecialistRoles,
  getSpecialistRolePermissions,
  normalizeSpecialistRoleKey
} from '../helpers/activeSpecialistRoleHelper';
import { getRoleDisplayLabel } from '../helpers/specialistRoleModuleHelper';
import { isFlowEngineGloballyEnabled, isLiaisonInboxEnabled, isPreManagerGloballyEnabled } from '../helpers/flowEngineConfigHelper';

const useActiveSpecialistRole = () => {
  const configuration = useSelector((state) => state.configuration);
  const roleLogin = useSelector((state) => state.userRole.roleLogin);

  const flowEngineEnabled = isFlowEngineGloballyEnabled(configuration);

  const liaisonEnabled = isLiaisonInboxEnabled(configuration);

  const availableRoles = useMemo(
    () => buildAvailableSpecialistRoles(roleLogin).filter((role) => {
      if (role.roleKey === 'liaison' && !liaisonEnabled) {
        return false;
      }
      return true;
    }),
    [liaisonEnabled, roleLogin]
  );

  const selectedRole = roleLogin?.roleSpecialistSelected || null;
  const roleKey = selectedRole?.roleKey || normalizeSpecialistRoleKey(selectedRole);
  const preManagerEnabled = isPreManagerGloballyEnabled(configuration);
  const permissions = getSpecialistRolePermissions(roleKey, flowEngineEnabled, {
    flowPreManagerEnabled: preManagerEnabled
  });

  const showSwitcher = flowEngineEnabled && availableRoles.length > 1;
  const showActiveRoleLabel = flowEngineEnabled && availableRoles.length > 0 && roleLogin?.isRoleSpecialistSelected;

  return {
    flowEngineEnabled,
    availableRoles,
    selectedRole,
    roleKey,
    isRoleSelected: !!roleLogin?.isRoleSpecialistSelected,
    showSwitcher,
    showActiveRoleLabel,
    needsRoleSelection: flowEngineEnabled && availableRoles.length > 1 && !roleLogin?.isRoleSpecialistSelected,
    ...permissions
  };
};

export const getActiveSpecialistRoleLabel = (selectedRole, t) => {
  if (!selectedRole?.name) {
    return t('specialist.selection.role.none', '(ninguno)');
  }

  return getRoleDisplayLabel(selectedRole.name, t);
};

export default useActiveSpecialistRole;
